import { request as http } from '@/utils/http'
import type {
  BusinessIncreaseRulesBatchValidityRequest,
  BusinessIncreaseRulesPageRequest,
  BusinessIncreaseRulesSaveRequest,
  BusinessIncreaseRulesUpdateRequest,
  BusinessIncreaseRulesVO,
  PrimaryKeyRequest
} from './types'
import type { PageResponse } from '@/api/sass/increase-rules/types'

/** 分页查询商务加价规则。 */
export const page = (params: BusinessIncreaseRulesPageRequest) => {
  return http.post<PageResponse<BusinessIncreaseRulesVO>>('/price/business-increase-rules/page', params)
}

/** 新增商务加价规则。 */
export const save = (params: BusinessIncreaseRulesSaveRequest) => {
  return http.post<boolean>('/price/business-increase-rules/save', params)
}

/** 修改商务加价规则。 */
export const update = (params: BusinessIncreaseRulesUpdateRequest) => {
  return http.post<boolean>('/price/business-increase-rules/update', params)
}

/** 获取商务加价规则详情。 */
export const get = (id: number | string) => {
  return http.post<BusinessIncreaseRulesVO>('/price/business-increase-rules/get', { id })
}

/** 批量启用商务加价规则。 */
export const batchOnline = (params: PrimaryKeyRequest) => {
  return http.post<boolean>('/price/business-increase-rules/batch-online', params)
}

/** 批量停用商务加价规则。 */
export const batchOffline = (params: PrimaryKeyRequest) => {
  return http.post<boolean>('/price/business-increase-rules/batch-offline', params)
}

/** 批量调整商务加价规则有效期。 */
export const batchUpdateValidDate = (params: BusinessIncreaseRulesBatchValidityRequest) => {
  return http.post<boolean>('/price/business-increase-rules/batch-update-valid-date', params)
}

/** 批量删除商务加价规则。 */
export const batchDelete = (params: PrimaryKeyRequest) => {
  return http.post<boolean>('/price/business-increase-rules/batch-delete', params)
}

